import React from "react";
import {
  createStyles,
  Group,
  Text,
  Avatar,
  Box,
  Flex,
  Select,
} from "@mantine/core";
import { IconShoppingCart, IconShip } from "@tabler/icons";
import { Discount2 } from "tabler-icons-react";

const useStyles = createStyles((theme) => ({
  statBox: {
    display: "flex",
    backgroundColor: "#f8f9fa",
    padding: theme.spacing.md,
    borderRadius: theme.radius.sm,
    flex: "0 0 auto",
    maxWidth: "200px",
    margin: `${theme.spacing.xs}px 0`,
  },
  statTitle: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 700,
    color: "#101F0C",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statValue: {
    color: "#F36825",
    fontSize: theme.fontSizes.lg,
    fontWeight: 700,
    marginTop: 4,
  },
  userStatusWrapper: {
    flex: 1,
    marginLeft: theme.spacing.xl * 2,
    display: "flex",
    alignItems: "center",
  },
  timeSelect: {
    width: "250px",
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[3]}`,
    backgroundColor: theme.white,
    "&:hover": {
      borderColor: theme.colors.blue[2],
    },
    "&:focus-within": {
      borderColor: theme.colors.blue[5],
      boxShadow: `${theme.shadows.sm} ${theme.colors.blue[5]}`,
    },
  },
}));

const icons = {
  user: IconShoppingCart,
  discount: Discount2,
  receipt: IconShoppingCart,
  coin: IconShip,
};

export default function SupplierStatsGrid({
  loading,
  data,
  datas,
  timeRange,
  onTimeRangeChange,
}) {
  const { classes } = useStyles();

  const fieldMap = {
    "Total Orders": "total_orders",
    "Total Sales": "total_sales",
    "Total Active Orders": "total_active_orders",
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return "0";
    return new Intl.NumberFormat().format(value);
  };

  const stats = datas.map((stat) => {
    if (
      !loading &&
      data &&
      Object.keys(data).length > 0 &&
      fieldMap[stat.title]
    ) {
      stat.value = data[fieldMap[stat.title]];
    } else {
      stat.value = 0;
    }
    const Icon = icons[stat.icon];
    return (
      <Box className={classes.statBox} key={stat.title}>
        <Avatar radius="sm" size="md" color="blue" style={{ marginRight: 12 }}>
          <Icon size={24} />
        </Avatar>
        <div>
          <Text className={classes.statTitle}>{stat.title}</Text>
          <Text className={classes.statValue}>{formatNumber(stat.value)}</Text>
        </div>
      </Box>
    );
  });

  return (
    <Flex
      gap="md"
      justify="space-between"
      align="center"
      style={{ position: "relative", width: "100%" }}
    >
      <Group
        spacing="md"
        position="apart"
        noWrap
        style={{ flex: 2, overflowX: "auto" }}
      >
        {stats}
      </Group>
      <div className={classes.userStatusWrapper}>
        <Select
          data={[
            { value: "DAILY", label: "Daily" },
            { value: "WEEKLY", label: "Weekly" },
            { value: "MONTHLY", label: "Monthly" },
            { value: "QUARTERLY", label: "Half Year" },
            { value: "YEARLY", label: "Yearly" },
          ]}
          value={timeRange}
          size="sm"
          placeholder="Select Range"
          onChange={onTimeRangeChange}
          className={classes.timeSelect}
        />
      </div>
    </Flex>
  );
}
